import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const JCB = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 16 16">
    <path
      d="M15 11.6667C15 12.403 14.403 13 13.6667 13H2.33333C1.597 13 1 12.403 1 11.6667V4.33333C1 3.597 1.597 3 2.33333 3H13.6667C14.403 3 15 3.597 15 4.33333V11.6667Z"
      fill="#CFD8DC"
    />
    <path
      d="M3.55637 4.33334C2.86004 4.33334 2.33337 4.77468 2.33337 5.53901V11.6667H4.49437C5.03804 11.6667 5.66671 11.1563 5.66671 10.4943V4.33334H3.55637Z"
      fill="#3F51B5"
    />
    <path
      d="M7.55637 4.33334C6.86004 4.33334 6.33337 4.77468 6.33337 5.53901V11.6667H8.49437C9.03804 11.6667 9.66671 11.1563 9.66671 10.4943V4.33334H7.55637Z"
      fill="#E53935"
    />
    <path
      d="M11.5564 4.33334C10.86 4.33334 10.3334 4.77468 10.3334 5.53901V11.6667H12.4944C13.038 11.6667 13.6667 11.1563 13.6667 10.4943V4.33334H11.5564Z"
      fill="#388E3C"
    />
    <path
      d="M5.26868 8.15102C5.26868 8.76268 4.47902 9.08535 3.90168 9.08535C3.27368 9.08535 2.71268 8.71202 2.59302 8.23702H3.01768C3.06835 8.52568 3.35802 8.72868 3.68002 8.72868C4.03668 8.72868 4.29135 8.47402 4.29135 8.15135V7.04768H5.26835V8.15102H5.26868ZM12.8687 8.01268C13.1227 8.01268 13.3004 7.75968 13.3004 7.50635C13.3004 7.25235 13.0794 7.03235 12.8254 7.03235H10.738V8.98302H12.8687C13.1564 8.98302 13.376 8.73068 13.3764 8.47668C13.3764 8.22368 13.1567 8.01268 12.8687 8.01268ZM11.5504 7.23568H12.21C12.378 7.23568 12.5304 7.38668 12.5304 7.55535C12.5304 7.72502 12.378 7.87768 12.21 7.87768H11.5504V7.23568ZM12.2264 8.78102H11.5507V8.13835H12.2264C12.3957 8.13835 12.548 8.29035 12.548 8.46002C12.548 8.62835 12.3957 8.78102 12.2264 8.78102ZM9.27035 7.39202C8.88102 7.30202 8.50835 7.24968 8.32202 7.24968C7.91602 7.24968 7.59502 7.58868 7.59502 8.01735C7.59502 8.44802 7.91602 8.78768 8.32202 8.78768C8.50835 8.78768 8.88102 8.75202 9.27035 8.66102V9.00135H7.64535C7.13802 9.00135 6.71535 8.55402 6.71535 8.01735C6.71535 7.48168 7.13802 7.03468 7.64535 7.03468H9.27035V7.39202Z"
      fill="#FAFAFA"
    />
  </SvgIcon>
));

JCB.displayName = 'JCB';

export default JCB;
